export default function LoadingBlock({ rows = 3, height = 48 }) {
  return (
    <div className="col gap-sm">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height }} />
      ))}
    </div>
  );
}
